module.exports = __webpack_public_path__ + "img/arrowdown.svg";